import { jqGetElemById } from 'util/global';
import { showGenericModal } from 'util/ui';


/**
 * Get data from ajax error data element
 * @return {Object} - error text data
 */
function getModalData() {
    return jqGetElemById('default-ajax-error').data();
}


/** Standard error modal (500, 404, etc) */
export function showStandardErrorModal() {
    const data = getModalData();
    if (data) {
        showGenericModal(data.errorTitle, data.errorContent);
    }
}


/** Timeout error modal */
export function showTimeoutErrorModal() {
    const data = getModalData();
    if (data) {
        showGenericModal(data.errorTitle, data.timeoutContent);
    }
}


/**
 * Handle error message from the backend
 * @param {jqXHR} response
 */
export function showBackendErrorModal(response) {
    if (response.responseJSON) {
        const { error } = response.responseJSON;
        showGenericModal(error.title, error.message);
    } else {
        // trying to debug strange 403 error - Carrie 1/3/19
        // eslint-disable-next-line no-console
        console.log(response);
    }
}


/**
 * Handles ajax responses, determines which modal to show based on response
 * @param {jqXHR} response
 */
export function errorModalHandler(response) {
    if (response.statusText === 'abort') {
        return;
    }
    if (response.status === 403) {
        showBackendErrorModal(response);
    } else if (response.statusText === 'timeout') {
        showTimeoutErrorModal();
    } else {
        showStandardErrorModal();
    }
}
